import React from 'react';

const UnidadeDeMedidaContext = React.createContext();

export default UnidadeDeMedidaContext;
